import { AxArtwork } from "@dynata/axiom3";
import unavailableImage from "@dynata/axiom3-images/png/general_stand.png";

export function FavoriteProjectsZeroState() {
  return (
    <AxArtwork
      title="You don't have any favorite projects"
      image={unavailableImage}
      description="Search projects and favorite them to track their progress here."
    />
  )
}